import * as yup from 'yup'

export const schema = yup.object({
  senceState: yup.boolean().required(),
  sence: yup
    .object({
      token: yup.string(),
      runOtec: yup.string(),
    })
    .when('senceState', {
      is: true,
      then: yup.object().shape({
        token: yup.string().required(),
        runOtec: yup.string().required(),
      }),
    })
    .nullable(),
})
export type FormValues = yup.InferType<typeof schema>

export const authorizedCompanies = new Set([
  // Wayne Enterprises
  '842dc5c4-c807-4f03-85fe-536113d84c8e',
  // Stark Industries
  '0a22ae17-c7f3-4dc3-ab49-5729d63c2688',
  // Komatsu
  'febd5f7d-9909-4723-bc2d-bbef82b17080',
])
